export default __webpack_public_path__ + "static/media/payment-successful.b995ac65.png";